/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

/**
 * Phaser Blend Modes to CSS Blend Modes Map.
 * 
 * @name Phaser.CSSBlendModes
 * @enum {string}
 * @memberOf Phaser
 * @readOnly
 * @since 3.12.0
 */

module.exports = [
    'normal',
    'multiply',
    'multiply',
    'screen',
    'overlay',
    'darken',
    'lighten',
    'color-dodge',
    'color-burn',
    'hard-light',
    'soft-light',
    'difference',
    'exclusion',
    'hue',
    'saturation',
    'color',
    'luminosity'
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/phaser/src/gameobjects/domelement/CSSBlendModes.js
// module id = 1713
// module chunks = 0